<!-- src/components/CalendarView.vue -->

<template>
    <section class="calendar">
		<a class="ical-link text-sm" v-bind:href="iCalLink">Export calendar</a>
		<FullCalendar ref="fullCalendar" :options="calendarOptions" :selectable="true" @dateClick="handleDateClick" />
		<div class="w-full p-2 mt-4">
			<p class="text-sm mb-2">Address for iCal format to use in calendar software:</p>
			<input readonly type="text" @focus="$event.target.select()" v-bind:value="iCalLink" class="w-full bg-cal-F4F2F2 p-2 rounded-sm text-sm">
		</div>
    </section>
</template>

<script>

import WebServices from '../../services/WebServices';
import '@fullcalendar/core/vdom' // solves problem with Vite
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import Vue from 'vue/dist/vue'

export default {


    components: { FullCalendar},

    data () {
        return {
            services: WebServices("UserProjects"),
			hashService: WebServices("Users/Me/iCalHash"),
			calendarOptions: {
				plugins: [dayGridPlugin, interactionPlugin],
				aspectRatio: 2,
				eventClick: this.handleDateClick,
				initialView: 'dayGridMonth',
				events: [],
				displayEventTime: false,
				headerToolbar: {
					left: '',
					center: 'title',
					right: 'today,prev,next',
				},
			},
			iCalLink: null,
			notifications: [],
        }
    },

    created () {
		this.load();
		this.iCalHash();
    },

    methods: {
        load () {
			this.services
				.getAll({}, "NoteNotifications")
				.then((response) => {
					const data = response.data;
					if (data.error) {
						swal({
							title: "Error",
							text: data.error,
							type: "error",
							confirmButtonColor: "#40B572"
						}, function() {
							swal.close();
						}.bind(this));

						return
					}

					// Get due dates.
					let events = data.data.map(project => {
						if (!project.notification_date) {
							return
						}

						return {
							title: "#" + project.project_id + " " + project.project.title,
							id: project.project_id,
							date: project.notification_date,
						}
					});

					// Remove undefined values.
					events = events.filter(function( element ) {
						return element !== undefined;
					});
					this.calendarOptions.events = events;

				}, (response) => {
					swal({
						title: "Error",
						text: data.error,
						type: "error",
						confirmButtonColor: "#40B572"
					}, function() {
						swal.close();
					}.bind(this));

					return
				});
		},
		iCalHash: function() {
			this.hashService
			.getAll()
			.then((response) => {
				let hash = response.data.hash
				this.iCalLink = window.location.origin + '/Calendar/' + hash + '/Ical'
			})
		},
		handleDateClick: function(arg) {
            this.$router.push({ name: 'projects.show', params : { projectId: arg.event.id} });
		},
		exportIcal: function() {
			Vue.http.get(
				Vue.baseUrl + '/Calendar/Ical',
				{responseType: 'blob'}
			).then((response) => {
				let file = new Blob([response.data], {type: 'text/calendar'});
          		window.open(URL.createObjectURL(file));
        	});
		},
    },

    watch: {
        '$route': function() {
            this.loadInitial()
        }
    },
}

</script>

<style>
.calendar .fc-event {
  cursor: pointer;
}

@media screen and (max-width: 768px) {
  .calendar thead {
    display: table-row;
  }
  .calendar td {
    display: table-cell;
  }
}

.calendar .ical-link {
  font-weight: 400;
  padding: 0.4em 0.65em;
  display: inline-block;
  background: #2c3e50;
  color: #ffffff;
  border-radius: 0.25em;
  line-height: 1.5em;
  text-decoration: none;
  text-align: center;
  position: absolute;
}

.calendar .ical-link:hover {
  background: #1a252f;
}
</style>

